import { useMutation } from '@tanstack/react-query';

import { MembershipType, DAY_OF_WEEK } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership-type/:id/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    id: string;
    is_active?: boolean;
    membership_type_allowed_times?: {
        day_of_week: DAY_OF_WEEK;
        from_time: string;
        to_time: string;
    }[];
    restricted_gateways?: string[];
}
const mutationFn = ({
    id,
    is_active,
    membership_type_allowed_times,
    restricted_gateways,
    parkingId,
}: DTO): Promise<MembershipType> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, id }), {
        is_active,
        membership_type_allowed_times,
        restricted_gateways,
    });
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as usePatchMembershipType };
